import { useAxiosRequest } from "api/axiosRequest"
import { BASE_URL } from "api/url_helper"
import axios from "axios"
import { useState } from "react"
import { toast } from "react-toastify"

export interface Tags {
  id: string
  tagName: string
  createdBy: string | null
  createdAt: string
  updatedBy: string | null
  updatedAt: string
  isDeleted: boolean
  sortOrder: number
}

export function useFetchTags() {
  const [tags, setTags] = useState<Tags[]>()
  const [isFetchTagsLoading, setIsFetchTagsLoading] = useState<boolean>(false)
  const request = useAxiosRequest()
  async function fetchTags() {
    try {
      setIsFetchTagsLoading(true)
      const data = await request<any, Tags[]>({
        url: `${BASE_URL}/prevetting/tags`,
      }).then((response) => response?.data)
      setTags(data)
    } catch (err: unknown) {
      const message = "Unable to get tags"
      if (axios.isAxiosError(err)) {
        toast.warn(message, {
          position: "bottom-right",
          autoClose: 8000,
        })
      }
    } finally {
      setIsFetchTagsLoading(false)
    }
  }
  return { tags, isFetchTagsLoading, fetchTags }
}
